export default contacts =>
  contacts
    .map(
      contact => `
  <div class="apcia-oahscy-card">
    <div class="apcia-6u2agv-container">
      <div class="apcia-1ucuwnb-inner">
        <div class="apcia-xukb2i-name">${contact.fullname}</div>
        ${contact.title ? `<p class="apcia-11ekrx2">${contact.title}</p>` : ''}
        ${
          contact.phone
            ? `<p class="apcia-xlajkl2-link"><a href="tel:${contact.phone}"
            class="apcia-1mjnjph-link"><i aria-label="icon: phone" class="anticon anticon-phone"><svg
              viewBox="64 64 896 896" focusable="false" class="" data-icon="phone" width="1em"
              height="1em" fill="currentColor" aria-hidden="true">
              <path
                d="M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z">
              </path>
            </svg></i> ${contact.phone}</a></p>`
            : ''
        }
        ${
          contact.email
            ? `<p class="apcia-xlajkl2-link"><a href="mailto:${contact.email}"
            class="apcia-1mjnjph-link"><i aria-label="icon: mail" class="anticon anticon-mail"><svg
              viewBox="64 64 896 896" focusable="false" class="" data-icon="mail" width="1em"
              height="1em" fill="currentColor" aria-hidden="true">
              <path
                d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z">
              </path>
            </svg></i> ${contact.email}</a></p>`
            : ''
        }
      </div>
    </div>
  </div>
`
    )
    .join('');
